import { LinkProps } from 'react-router-dom'

import { copyAttackForReuse } from 'components/attacks/utils/attacks'

export function isValidRerunCandidate(targetType, command) {
  if (targetType !== 'Container') {
    return true
  }

  switch (command.toLowerCase()) {
    // Resource type attacks cannot be run against containers
    case 'cpu':
    case 'memory':
    case 'io':
    case 'disk':
      return false
    default:
      return true
  }
}

/**
 * Build a URL to an attack, as well as generate the attack state to pass to that route
 *
 * @param attack {} An attack data object
 * @param metadata [] attack metadata list
 * @returns {{}}
 */
export function generateRerunAttackLinkTo(attack, metadata): LinkProps {
  const isHostAttack = attack?.infra_target?.targetType === 'Host'
  if (attack?.service_id) {
    return {
      to: '/attacks/new/services',
      state: {
        attack: copyAttackForReuse(attack, metadata),
        service: { id: attack?.service_id },
        userDefinedService: { serviceId: attack?.service_id }
      }
    }
  }

  return {
    to: `/attacks/new/${isHostAttack ? 'hosts' : 'containers'}`,
    state: { attack: copyAttackForReuse(attack, metadata) }
  }
}
